import React from 'react';
import {classes, style} from './doppe-action-view-inner-content-close-button.st.css';
import {IconButton} from "@wix/devzai-utils-react";
import {WixIconX} from "@wix/devzai-common-client";

export const DoppeActionViewInnerContentCloseButton = React.memo(function DoppeActionViewInnerContentCloseButton (props: DoppeActionViewInnerContentCloseButton.Props) {
    const {
        onCloseButtonClick,

        className,
        ...htmlAttributes
    } = props;

    return (
        <div
            {...htmlAttributes}
            className={style(classes.root, className)}
        >
            <IconButton
                className={style(classes.iconButton, {})}
                icon={WixIconX}
                onClick={onCloseButtonClick}
            />
        </div>
    );
});

export namespace DoppeActionViewInnerContentCloseButton {

    export interface Props extends React.HTMLAttributes<any> {
        onCloseButtonClick: () => void;
    }
}
